module.exports = __webpack_public_path__ + "static/media/up.ac23f59c.svg";